/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DimensionPrecomputeStatusResult {
    getFixupPrototypeFunction() { return DimensionPrecomputeStatusResult.fixupPrototype; }

    static newInstance(model: Partial<DimensionPrecomputeStatusResult>): DimensionPrecomputeStatusResult {
        let obj = Object.assign(new DimensionPrecomputeStatusResult(), model);
        DimensionPrecomputeStatusResult.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DimensionPrecomputeStatusResult>): DimensionPrecomputeStatusResult {
        if (!model) return null;
        return DimensionPrecomputeStatusResult.newInstance(<DimensionPrecomputeStatusResult> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DimensionPrecomputeStatusResult) {
        if (!obj) return;

        models.DimensionPrecomputeStatusResult.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DimensionPrecomputeStatusResult): boolean {
        Object.setPrototypeOf(obj, DimensionPrecomputeStatusResult.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.by_account) {
            for (let val of this.by_account) {
                models.DimensionPrecomputeAccountStatus.fixupPrototype(val);
            }
        }
    }

    /**
     * Dimension definition ID
     */
    dimension_id: string;

    /**
     * Worst-case aggregate across all billing accounts
     */
    status: models.DimensionPrecomputeStatus;

    /**
     * Per-billing-account detail
     */
    by_account: Array<models.DimensionPrecomputeAccountStatus>;

    /**
     * Status message, e.g. reason a dimension was not found or not accessible
     */
    message: string;

}
